import * as React from 'react';
import { Box, TextField, IconButton, Popover, Button, Tooltip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { context } from '../context';

export const DateRangeSelector = () => {
    const { startDate, setStartDate, endDate, setEndDate } = React.useContext(context);
    const [anchorEl, setAnchorEl] = React.useState(null);
    
    // 临时状态，用于在弹窗中编辑
    const [tempStartDate, setTempStartDate] = React.useState(startDate);
    const [tempEndDate, setTempEndDate] = React.useState(endDate);

    const handleOpen = (event) => {
        setTempStartDate(startDate);
        setTempEndDate(endDate);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleConfirm = () => {
        setStartDate(tempStartDate);
        setEndDate(tempEndDate);
        handleClose();
    };

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setTempStartDate('');
        setTempEndDate('');
        handleClose();
    };

    const open = Boolean(anchorEl);
    const hasDateFilter = startDate || endDate;

    // 格式化显示的日期范围（用于 Tooltip）
    const getDateRangeLabel = () => {
        if (startDate && endDate) {
            return `${startDate} ~ ${endDate}`;
        } else if (startDate) {
            return `${startDate} 起`;
        } else if (endDate) {
            return `至 ${endDate}`;
        }
        return '筛选日期';
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={getDateRangeLabel()} arrow>
                <IconButton 
                    onClick={handleOpen}
                    size="small"
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '10px',
                        border: '1px solid',
                        borderColor: hasDateFilter ? 'primary.main' : 'rgba(0, 0, 0, 0.1)',
                        bgcolor: hasDateFilter ? 'rgba(255, 139, 147, 0.08)' : 'transparent',
                        color: hasDateFilter ? 'primary.main' : 'text.secondary',
                        '&:hover': {
                            bgcolor: 'rgba(255, 139, 147, 0.12)',
                            borderColor: 'primary.light',
                        },
                    }}
                >
                    <CalendarMonthIcon sx={{ fontSize: '1.125rem' }} />
                </IconButton>
            </Tooltip>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                sx={{
                    mt: 1,
                    '& .MuiPopover-paper': {
                        borderRadius: '12px',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                        border: '1px solid rgba(0, 0, 0, 0.04)',
                    },
                }}
            >
                <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 260 }}>
                    <TextField
                        label="开始日期"
                        type="date"
                        size="small"
                        fullWidth
                        value={tempStartDate}
                        onChange={(e) => setTempStartDate(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            },
                        }}
                    />
                    <TextField
                        label="结束日期"
                        type="date"
                        size="small"
                        fullWidth
                        value={tempEndDate}
                        onChange={(e) => setTempEndDate(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            },
                        }}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, pt: 0.5 }}>
                        <Button 
                            size="small" 
                            onClick={handleClear}
                            sx={{ 
                                color: 'text.secondary',
                                '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' },
                            }}
                        >
                            清除
                        </Button>
                        <Button 
                            size="small" 
                            variant="contained" 
                            onClick={handleConfirm}
                            sx={{
                                bgcolor: 'primary.main',
                                boxShadow: 'none',
                                '&:hover': {
                                    bgcolor: 'primary.dark',
                                    boxShadow: '0 4px 12px rgba(255, 139, 147, 0.3)',
                                },
                            }}
                        >
                            确定
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </Box>
    );
}
